import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {StreamsSideListComponent} from './streams-side-list.component';
import { ImgLazyLoadingModule } from '../image-lazy-loading/image-lazy-loading.module';

@NgModule({
  declarations: [ StreamsSideListComponent ],
  imports: [
    RouterModule,
    CommonModule,
    ImgLazyLoadingModule
  ],
  exports: [ StreamsSideListComponent ]
})

export class StreamsSideListModule {}
